/**
 * 回傳 Meta Stript 標籤
 *
 * @returns { scripts }
 */

import type { ReactiveHead } from '@unhead/vue';

export function useMetaScript() {
  const { captchaSiteKey } = useWebsite();
  const { isCN } = useLanguage();

  const scripts = ref<ReactiveHead['script']>([
    // reCAPTCHA：用於表單驗證
    {
      key: 'recaptcha',
      src: isCN.value
        ? 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit'
        : `https://www.google.com/recaptcha/api.js?render=${captchaSiteKey.value}`,
      async: false,
      defer: !isCN.value,
    },
    {
      key: 'utm-cookie-appender',
      src: '/resource/adv-utm-cookie-appender.js',
      async: false,
      defer: true,
    },
    !isCN.value && {
      key: 'gtag-G-DXEVJCDPT3',
      src: 'https://www.googletagmanager.com/gtag/js?id=G-DXEVJCDPT3',
      async: false,
      defer: true,
    },
    !isCN.value && {
      key: 'gtag-AW-10991029301',
      src: 'https://www.googletagmanager.com/gtag/js?id=AW-10991029301',
      async: false,
      defer: true,
    },
  ]);

  /**
   * * NOTE: 曾經有使用到但現在已經移除的 script，怕未來又被說要加回來所以先紀錄一下有哪些
   * @date 2026-03-25
   *
   * @neme VWO Smart Code
   * @description 用於 A/B Testing
   * @script /resource/vwo-smart-code.js
   *
   * @neme Advantech Live Chatbot
   * @description 聊天機器人
   * @script https://advcloudfiles.advantech.com/support/live-chat/1.6.0/dist/main.min.js
   *
   * @neme Advantech Web Tracking Logs
   * @description 研華的追蹤碼
   * @script https://advcloudfiles.advantech.com/components/plugins/adv-web-tracking/1.2.0/dist/adv-web-tracking-logs.min.js
   *
   * @name Advantech Video Player
   * @description 用於影片播放器
   * @script https://blob.advantech.com/web/js/advantech.videoplayer/2.0.2/dist/advantech.videoplayer.min.js
   */

  return { scripts };
}
